module.exports = __webpack_public_path__ + "static/media/4_2.9d411cf8.jpg";